import { createContext, useContext } from "react";

export interface TrackingValidityState {
  trackingValid: boolean;
  setTrackingValid: (valid: boolean) => void;
}

export const TrackingValidityContext = createContext<TrackingValidityState>({
  trackingValid: true,
  setTrackingValid: () => undefined,
});

export const useTrackingValidity = () => useContext(TrackingValidityContext);
